exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datatable-wrapper[data-v-e914f714]{position:relative}", ""]);

// exports
